import React from "react";

/** Side-by-side column section for user add/edit modal */
export default function UserFormSection({
  title,
  children,
  className = "",
  onToggleMaximize,
  headExtra,
  hideHead = false,
  footer = null,
}) {
  const showMaximize = typeof onToggleMaximize === "function";
  const showHead = !hideHead && (title != null || headExtra || showMaximize);

  return (
    <section className={["user-modal-fold", className].filter(Boolean).join(" ")}>
      {showHead ? (
        <div
          className={[
            "user-modal-fold__head",
            headExtra ? "user-modal-fold__head--with-control" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <div className="user-modal-fold__head-main">
            {title != null && title !== "" ? (
              <h6 className="user-modal-fold__title">{title}</h6>
            ) : (
              <span className="user-modal-fold__title" aria-hidden="true" />
            )}
            {showMaximize ? (
              <button
                type="button"
                className="user-modal-fold__maximize"
                onClick={onToggleMaximize}
                aria-label="Open in larger view"
                title="Open in larger view"
              >
                <i className="fas fa-expand" aria-hidden="true" />
              </button>
            ) : null}
          </div>
          {headExtra ? (
            <div className="user-modal-fold__head-extra">{headExtra}</div>
          ) : null}
        </div>
      ) : null}
      <div className="user-modal-fold__body">{children}</div>
      {footer ? <div className="user-modal-fold__footer">{footer}</div> : null}
    </section>
  );
}
